import { FC } from 'react';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import EditorLink from 'lowcode/components/EditorLink';
import EditorImg from './CommonImage';
import styled from './index.module.scss';
import { IProductItem } from '@/components/MembersDay/type';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { NA_SITES } from '@/constants/membersday';
import gtm from '@/utils/gtm';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';

interface IProps {
    data: IProductItem;
    list_name?: string;
    passLogin?: boolean;
    module?: string;
}

const CommonCardA: FC<IProps> = ({ data, list_name }) => {
    const { locale } = getLocal();
    const { t } = useLang('membersstore');

    const buyHandle = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            list_name,
            product_name: data.title,
            price: data.memberPrice,
            tag: 'none',
            quantity: 1,
            button_name: t('accessories.buy_now'),
        });
        const { compareAtPrice, memberPrice, inventoryQuantity, title, variantId, productId, imageUrl } = data;
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
            {
                compareAtPrice: Number(compareAtPrice),
                price: Number(memberPrice),
                inventoryQuantity,
                inventoryPolicy: data?.inventoryPolicy || 'deny',
                productTitle: data?.productTitle || title,
                skuTitle: data?.skuTitle || title,
                variantId,
                productId,
                img: data?.img || imageUrl,
                variantImg: data?.variantImg || imageUrl,
                quantity: 1,
            } as ItfEcoCartItem,
        ]);
    };

    return (
        <div className={`${styled.content} CommonCardA`}>
            <div>
                <EditorImg pc={data.imageUrl} h5={data.imageUrl} />
                {data.discount && <div className="off">{data.discount}</div>}
                <div className="card-msg-box">
                    <EditorLink
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                        }}
                        traget="_blank"
                        href={data.productUrl}
                    >
                        <div className="card-title">
                            {NA_SITES.includes(locale) ? 'EcoFlow ' : ''}
                            {data.title.replace(`(${t('product_price_member')})`, '')}
                        </div>
                    </EditorLink>

                    {data.subtitle1 && <p className="card-subtitle">{data.subtitle1}</p>}
                </div>
            </div>
            <div className="card-msg-box">
                <div className="card-price-a">
                    <div className="card-price-a-l">{data.memberPrice2}</div>
                    <span className="card-price-a-r">{data.compareAtPrice2}</span>
                </div>
                <button className="card-btn" onClick={buyHandle}>
                    {t('accessories.buy_now')}
                </button>
            </div>
        </div>
    );
};

export default CommonCardA;
